import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
    en: {
        copyright: "© IDCS & E-KARTE ltd.",
        search: {
            amount2: "replenishment amount",
            system: "search in cards types",
            companies: "search in company structure",
            subcompanies: "select a Place of sale",
            operation: "select type of using",
            terminal: "select a terminal",
            card: "search card",
            pattern: "search by pattern",
            byCard: "search by card number",
            all: "all",
            byPattern: "search by Cardholder",
        },
        title: {
            login: "Authorization",
            main: "E-Karte manager",
            print: "Data request parameters",
            card_pin: "WEB PIN changing",
            status_card: "Change card status",
            card_copy: "Profile data copying",
            extend_card: "Valid date change",
            smsAuth: "SMS centr autorisation"
        },
        login: {
            domain: "Partner ID",
            login: "User",
            pass: "Password"
        },
        tooltip: {
            needDisplay: "Uncheck for using in mobile pos application",
            scFilter: "POS reports filter by Place of sale",
            mobileParam: "Parametr in transactions",
        },
        dialog: {
            confirm: "Delete entry",
            aconfirm: "Confirm action",
            tconfirm: "Proceed the action to api ?",
            tchangettl: "Change transaction status",
            tchangeqst: "Are you confirm change status of the transaction ?",
            delete: "You want to delete the entry. Are you sure ?"
        },
        button: {
            login: "Login",
            apply: "Apply",
            save: "Save",
            delete: "Delete",
            add: "Add",
            search: "Search",
            cancel: "Cancel",
            reset: "cancel",
            select: "Select",
            extend: "Valid date",
            block: "status",
            edit: "change",
            ok: "Confirm",
            clone: "Clone",
            switch_group: "Change group",
            download: "receive",
            check: "Validate",
            send: "Send",
            smsauth: "SMS auth"
        },
        cardtypes: {
            all: "all",
            valid: "valid",
            invalid: "invalid"
        },
        showZeroTypes: {
            all: "Show all cards",
            exclude: "Show cards without zero balance",
            only: "Show cards only with zero balance"
        },
        rules: {
            read: "Read",
            create: "Create",
            update: "Update",
            delete: "Delete",
            menu: " Menu Access Control",
            functions: "Menu user action control",
            records: "Action controls for records",
            profiles_r: "Profiles (menu)",
            struct_r: "Structure (menu)",
            struct_m: "Company structure",
            struct_s: "Connected cards type structure",
            struct_l: "Stucture for filters",
            summary_r: "Summary (menu)",
            trans_r: "Transactions (menu)",
            cards_r: "List of cards (menu)",
            report_r: "Reports (menu)",
            stats_r: "Graphs (menu)",
            log_r: "Logs (menu)",
            utils_r: "Admin control (menu)",
            cardDets_r: "Card expanded (menu)",
            info_r: "Home (menu)",
            export_r: "Export for external client",
            remote_r: "Remote user for program",
            fstat_w: "Status change",
            fpin_r: "Read PIN",
            fpin_w: "Change PIN",
            fcopy_t: "Card profile copying",
            posreport_r: "POS reports (menu)",
            fvalid_w: "Change card valid date",
            ftrstat_w: "Change transaction status",
            fmode_s: "Interface switch",
            actlog_r: "Activity log",
            fcused_y: "Clear card bad used",
            tickets_u: "Tickets(User)",
            tickets_a: "Tickets(Admin)",
        },
        rec_types: {
            CardRecord: "Card",
            CardDetailRecord: "Card detail",
            CompanyRecord: "Company",
            SubCompanyRecord: "Place of sale",
            TerminalRecord: "Terminal",
            TransactionRecord: "Transaction",
            TerminalDetailRecord: "Connected card type",
            SystemDetailRecord: "Type of usage",
            SystemRecord: "Card type",
            UserRecord: "User",
            LogRecord: "LOG",
            UserGroupRecord: "User group",
            ReportRecord: "Report",
            ErrorRecord: " Message editing",
            FrameRecord: "Info frame"
        },
        merch: {
            top: "Custom top",
            dayplus0: "TODAY",
            dayplus1: "TOMORROW",
            dayplus2: "DAY AFTER TOMORROW",
            total: "Total messages",
            info1: "Please select target audience of clients",
            info2: "Additional options for selecting recipients",
            info3: "Please select message recipients",
            info4: "Compose message text",
            info5: "Check the messages are correct",
            info6: "Please schedule the sending",
            phonefph: "Please select a field with a phone number",
            phonef: "Phone field",
            smsph: "When entering the text of the message, insert personal variables if necessary",
            nonamedays: "Please select at least one day to search",
            nophones: "No entries found with the correct phone number",
            nomsgtext: "You must enter the text of the message to go to the next step",
            phfounded: "Found {count} valid phone numbers",
            selclients: "Selected {sels} records from {total}",
            statmsg: "Send {count} sms messages to {target} recipients",
            schedtypes: [{
                    text: "Send as soon as possible",
                    title: "Send now",
                    value: "1",
                    icon: "mdi-send-check"
                },
                {
                    text: "Schedule the mailing at the specified time",
                    title: "Schedule",
                    value: "2",
                    icon: "mdi-send-clock"
                },
                {
                    text: "Set to queue in IDCS SMS center and send it manually",
                    title: "Queue",
                    value: "3",
                    icon: "mdi-send"
                },
            ],
            state: "State",
            count: "Count of sms",
            send2sms: "Send to IDCS SMS Centrs",
            message: "Message text",
            noclients: "No recipients selected",
            StaticQueries: "One-time sending",
            Schedule: "Automatic sending",
            schedules: [{
                text: "Birthday",
                value: 0
            }, {
                text: "Day of name",
                value: 1
            }, {
                text: "Burning amount",
                value: 2
            }],
            steps: [{
                text: "Select recipients",
                value: 1
            }, {
                text: "Filter",
                value: 2
            }, {
                text: "Selection result",
                value: 3
            }, {
                text: "Message",
                value: 4
            }, {
                text: "Check",
                value: 5
            }, {
                text: "Send",
                value: 6
            }],
            cltypes: [{
                text: "SMS",
                value: 0
            }, {
                text: "E-mail",
                value: 1
            }],
            days: [{
                    text: "Send on the day of the event",
                    value: 0
                },
                {
                    text: "Send the day before the event",
                    value: 1
                },
                {
                    text: "Send 2 days before the event",
                    value: 2
                },
                {
                    text: "Send 3 days before the event",
                    value: 3
                },
                {
                    text: "Send 4 days before the event",
                    value: 4
                },
                {
                    text: "Send 5 days before the event",
                    value: 5
                },
                {
                    text: "Send 6 days before the event",
                    value: 6
                },
                {
                    text: "Send a week before the event",
                    value: 7
                },
                {
                    text: "Send one month before the event",
                    value: 30
                }
            ],

            // msgcheck: "Check status",
            // start_unset: "Task unscheduled. Will be schedule at SMS center.",
            smsname: "Sending list name",
            sendTitle: "Enter a name for the sending list",
            // from: "From date",
            // type: "Type of client",
            // types: [{ text: "SMS", value: 0 }, { text: "E-mail", value: 1 }],
            // select: "Selection method",
            selects: [{
                    text: "All clients",
                    value: 0,
                    desc: "List of all clients",
                    sort: "Sort by total count of card uses"
                },
                {
                    text: "By client activity",
                    value: 4,
                    desc: "Active clients for the selected period",
                    sort: "Sort by last activity date"
                },
                {
                    text: "By inactivity of clients",
                    value: 6,
                    desc: "Clients having no visits for the selected period",
                    sort: "Sort by date of last activity"
                },
                {
                    text: "By maximum payment",
                    value: 1,
                    desc: "Clients and their maximum payment for the selected period",
                    sort: "Sort by payment amount"
                },
                {
                    text: "By maximum purchase",
                    value: 5,
                    desc: "Customers and the amount of their maximum purchase for the selected period",
                    sort: "Sort by purchase amount"
                },
                {
                    text: "By count of purchases",
                    value: 7,
                    desc: "Customers and their count of purchases for the selected period",
                    sort: "Sort by count of purchases"
                },
                {
                    text: "By card balances",
                    value: 2,
                    desc: "Clients and their card balances",
                    sort: "Sorted by the amount of the balance"
                },
                {
                    text: "By card discount",
                    value: 3,
                    desc: "Customers and their discount by card",
                    sort: "Sort by discount value"
                },
                {
                    text: "By day of name",
                    value: 8,
                    desc: "Customers with a coming day of name",
                    sort: "Sort by creation date"
                },
                {
                    text: "By birthday",
                    value: 9,
                    desc: "Happy birthday clients",
                    sort: "Sort by creation date"
                },
                {
                    text: "By discount level",
                    value: 10,
                    desc: "Customers with near next discount level",
                    sort: "Sort by totla card purchases"
                },
            ],
            customval: ["Creation date", "Purchase amount", "Card balance", "Card discount", "Last transaction", "Registration amount", "Last use", "Count of purchases", "", "", "Total purchases"],
            tops: [{
                text: "All",
                value: 0
            }, {
                text: "Top 5",
                value: 1
            }, {
                text: "Top 25",
                value: 2
            }, {
                text: "Top 50",
                value: 3
            }, {
                text: "Custom value",
                value: 4
            }],
            nameday: [{
                text: "Today",
                value: 0
            }, {
                text: "Tomorrow",
                value: 1
            }, {
                text: "The day after tomorrow",
                value: 2
            }, {
                text: "Current week",
                value: 3
            }],

            dtitle: "Event to check",
            f: {
                discamt: "Amount to next discount level",
                discperc: "Next level discount",
                nameday: "Search period",
                txtnameday: "Specify a search limit for the closest name days",
                phnameday: "When will the day of name",
                txtperiod: "Event time limit",
                txtsubcompany: "Restricted by Event Location",
                top: "Count of recipients",
                txttop: "Limit the count of recipients",
                next: "Next event check",
                range: "Period",
                phrange: "All time",
                cltype: "Type of users for sending",
                phsubcompanies: "All Branches",
                schedule: "Event type",
                name: "Sending name",
                phname: "Name of the sending list with which it will be registered in IDCS SMS Centrs",
                trigger_type: "Event type",
                message: "Message",
                phmessage: "Enter your message text",
                created: "Created",
                lastrun: "Date of last event",
                lastcode: "Last event code",
                total: "Total messages",
                days2trigger: "Pre-time sending",
                minamount: "Minimal burning amount in cents. Default value is greater 0. Amount parameter in message is {amount}",
                sendat: "Sending time"
            }
        },
        ticket: {
            title: "Ticket",
            type: "Type",
            description: "Description",
            closedat: "Completed",
            resume: "Resume",
            domain: "Domain",
            search_l: "Text to search",
            search: "Enter text to search",
            status_l: "Filter tickets by status",
            status_ph: "All tickets",
            sender: "Sender",
            types: [{
                text: "Free form",
                value: 0,
                description: ""
            }, {
                text: "Transfer between cards",
                value: 1,
                description: "Transfer [___] Eur from [___] to [___]"
            }, {
                text: "Cancel transaction",
                value: 2,
                description: "Reversal transaction with number [___] from terminal [___] at [___]"
            }, {
                text: "Cancel transaction and start new",
                value: 3,
                description: "Reversal transaction with number [___] from terminal [___] at [___] and transfer [___] Eur to [___]"
            }, {
                text: "Get WEB PIN of gift card",
                value: 4,
                description: "Please send the WEB PIN of card number [___]"
            }],
            status: [{
                text: "Draft",
                value: 0
            }, {
                text: "Active",
                value: 1
            }, {
                text: "In progress",
                value: 2
            }, {
                text: "Completed",
                value: 3
            }, {
                text: "Canceled",
                value: 4
            }],
            msg: {
                canceled: "Ticket canceled",
                deleted: "Ticket deleted",
                saved: "Ticket saved",
                error: "Error"
            },
            btn: {
                complete: "Complete",
                save: "Save as non complate",
                delete: "Delete",
                cancel: "Cancel",
                todraft: "Save as draft",
                start: "Send to processing"
            }
        },
        actlog: {
            actions: ["", "Set valid", "Set status", "Set PIN", "Clone card", "Update", "Delete", "Create", "Set parent", "Block", "Login"],
            group: "Group",
            user: "User",
            action: "Action",
            idx: "ID",
            type: "Type",
            data: "Data",
            comment: "Comment",
            sys_data: "Additional",
            request: "URI"
        },
        // profile: {
        //     msgcheck: "Check status",
        //     start_unset: "Task unscheduled. Will be schedule at SMS center.",
        //     smsname: "Name of the task",
        //     sendTitle: "Set parameters of the task",
        //     from: "From date",
        //     type: "Type of client",
        //     types: [{ text: "SMS", value: 0 }, { text: "E-mail", value: 1 }],
        //     select: "Selection method",
        //     selects: [{ text: "Last activity", value: 4, desc: "" }, { text: "Maximum registration", value: 0, desc: "" }, { text: "Maximum purchase", value: 1, desc: "" }, { text: "Maximum card bilance", value: 2, desc: "" }, { text: "Maximum discount", value: 3, desc: "" }],
        //     customval: ["Registration amount", "Purchase amount", "Debit", "Discount", "Last activity"],
        //     tops: [{ text: "All", value: 0 }, { text: "Top 5", value: 1 }, { text: "Top 10", value: 2 }, { text: "Top 50", value: 3 }, { text: "Custom top", value: 4 }],
        //     top: "Count of records",
        // },
        admin: {
            logst1: "Table LOG",
            logst2: "Total records is {count}",
            F1name: "Button F1 name",
            F2name: "Button F2 name",
            baseutils: "Base utils",
            until: "Clear all data before date",
            cb900: "Command 900 (REPORTS)",
            cb1000: "Command 1000 (BINS)",
            cb1100: "Command 1100 (INFO)",
            mobiface: "Mobile interface",
            freecards: "Free cards",
            fwidth: "Frame width",
            fheight: "Frame height",
            actions: "Actions",
            fcardlen: "Card length in frame",
            deflang: "Default language in frame",
            frames: "List of frames",
            errorid: "Message ID",
            usersupp: "Access Management",
            errors: "Messages",
            functions: "Additional options",
            reports: "Reports",
            users: "Users",
            bins: "List of BINs",
            groups: "User groups",
            errorId: "code",
            iface: "Interface type",
            group_cust: "Other group parameters",
            smsdisclevels: "Discount rules for SMS sending. Format: level amount (EUR) - Remains amount to trigger (EUR) / Next level discount (%)",
            newcmsonly: "https://cms.e-kartes.lv only",
            def_message: "Global message",
            rules: "Access rules",
            l_editor_type: "Cadr editor type",
            pinFlags: [{
                value: 0,
                text: "Not used"
            }, {
                value: 1,
                text: "Ask before INFO command"
            }, {
                value: 2,
                text: "Ask before DEAL command"
            }],
            editor_type: [
                "Simple",
                "Extended data collection (sms)",
            ],
            frame_type: [
                "Gift card",
                "Client card SJZ",
                "Client card erased GRD",
                "Reversed client card",
            ],
            interface_type: [
                "Admin",
                "Gift card",
                "Client card SJZ",
                "Client card erased GRD",
                "Reversed client card",
            ],
            // interface_type: {
            //     common: "Admin",
            //     debet: "Gift card",
            //     client: "Client card SJZ",
            //     debet: "Client card GRD",
            //     debet: "Gift card",
            // }
        },
        session: {
            title: "Warning!",
            text: "Your session will be expired soon! Please close the window to continue.",
        },
        trans: {
            all_data: "show correction",
            tooltip: {
                count: "Transactions count for the selected period"
            }
        },
        label: {
            hidetext: "Hide menu text",
            for: "for",
            modified: "Updated",
            not_found: "Nothing to found",
            placeholder: "Please enter data",
            toDisplay: "on display",
            toXml: "to file (xml)",
            toCsv: "to file (csv)",
            toExcel: "to file (MS Excel)",
            includeAll: "Enable all additional fields",
            excludeAll: "Disable all additional fields",
            deals: "Transaction number",
            rowPerPage: "Row per page",
            found: "Founded {count} records",
            nodata: "Nothing found for your request"
        },
        field: {
            searchin:"Select additional systems for card info searching",
            smsuser: "SMS user",
            smspass: "SMS password",
            smscompany: "SMS company",
            smsdebit: "SMS debit",
            smstarif: "SMS tarif",
            smssender: "SMS sender",
            params: "Parameters",
            frametype: "Type of frame response",
            errors: "Errors count",
            hash: "Hash ID",
            amount2Eu: ["Par2 summ", "Replenishment amount", "Payment by cust. card", "Payment by cust. card", "Purchase registartion"],
            amount1Eu: ["Par1 summ", "Payment amount", "Purchase registartion", "Purchase registartion", "Payment by cust. card"],
            amount2: ["Par2 summ", "Replenishment amount", "Payment by cust. card", "Payment by cust. card", "Purchase registartion"],
            amount1: ["Par1 summ", "Payment amount", "Purchase registartion", "Purchase registartion", "Payment by cust. card"],
            totalAmount1Eu: ["Total of par1", "Total of payment amount", "Total of purchase registartion", "Total of purchase registartion", "Total of payment by cust. card"],
            totalAmount2Eu: ["Total of par2", "Total of replenishment amount", "Total of payment by cust. card", "Total of payment by cust. card", "Total of purchase registartion"],
            d_debet: ["Calculated card balance", "Calculated card balance", "Calculated card balance", "Calculated card balance", "Calculated card balance"],
            counter: "Count of transactions",
            current_discount: "Calculated discount",
            amount_discount: "Discount amount",
            amount_debit: "Card balance",
            debit_n: "Accumulated amount",
            reversed: "Roll-back date",
            carddetail: "Card nr.",
            CardDetail: "Card nr.",
            terminaldetail: "Terminal ID",
            TerminalDetail: "Terminal ID",
            id: "Terminal ID",
            Terminal: "Terminal ID",
            Company: "Company",
            companyName: "Place of sale",
            SubCompany: "Place of sale",
            companySubName: "Place of sale",
            debet_nEu: "Accumulated amount",
            debet_0Eu: "Card balance",
            amountDebetEu: "Card balance",
            debetBilance: "Card balance",
            lastUsed: "Last used",
            used: "Count of transactions",
            validc: "Card livetime",
            lastModified: "Last modified",
            System: "Cards type",
            totalTrans: "Count of transactions",
            cmd: "Command",
            cmd900x: "X-report",
            cmd900z: "Z-report",
            cmd1000: "BIN",
            cmd1100: "INFO",
            cmd1200: "TRANS",
            cmd1300: "ROLL",
            cmd1200p: "PRN trans",
            cmd1300p: "PRN roll",
            errorResp: "error resp",
            errorCmd: "error cmd",
            totalc: "total cmd",
            totalp: "total prn",
            firstName: "Client info 1",
            secondName: "Client info 2",
            m1: "Jan",
            m2: "Feb",
            m3: "Mar",
            m4: "Apr",
            m5: "May",
            m6: "Jun",
            m7: "Jul",
            m8: "Aug",
            m9: "Sep",
            m10: "Oct",
            m11: "Nov",
            m12: "Dec",
            nextMonth: "Accumulations for remove",
            regNumber: "Client info 3",
            day: "Day of month",
            totals: "Fields for summ",
            sysdata: "System parameters",
            fields: "Selection fields",
            filtrs: "Fields for filtrs",
            repid: "Report code",
            inputPars: "Report input parameters",
            nameId: "Translate code",
            sorted: "Report picture code",
            errorId: "Translate code",
            password: "Password",
            created_: "Creation date",
            rec_nr: "Receipt nr.",
            c_company_name: "Client info 3",
            c_company_subname: "Client info 4",
            reg_num: "Client info 5",
            last_name: "Client info 2",
            subcompany_name: "Client info 4",
            company_name: "Client info 3",
            regnr: "Client info 5",
            additional: "Additional info",
            last_trans: "Last transaction date",
            next_month: "Burnable accumulation",

            ovalid: "Valid to",
            validcd: "Valid to",
            user_group: "Group",
            pattern: "Pattern",
            pos: "#",
            pin: "WEB PIN",
            bad_used: "Error count",
            last_used: "Last used",
            created: "Date and time",
            dt: "Date and time",
            req_dt: "Request created",
            last_modified: "Last modified",
            modified: "Last modified",
            req_command: "Command Code",
            code: "Response Code",
            message: "Answer on terminal display",
            ip: "IP address",
            name: "Name",
            card: "Card",
            req_ms: "Card",
            status: "Status",
            dbtMinus: "Amount paid",
            dbtPlus: "Replenished Amount",
            repNo: "Reports #",
            lastResponseId: "Response ID",
            lastRequestId: "Request ID",
            operation: "Type of use",
            Operation: "Type of use",
            terminal: "Terminal",
            req_terminal: "Terminal",
            system: "Card type",
            operNrDef: "Operation by default",
            bin: "BINs",
            justTrans: "just transaction",
            needOperNr: "Operation Nr is necessary",
            debetIn: "Replenishment option",
            extset: "Additional parameters",
            pinFlag: "PIN settings",
            checkSumFormula: "Card check formula",
            valid: "Expiry date",
            operNr: "oper Nr",
            reversal: "Cancellation is available",
            req_id: "request id",
            resp_id: "response id",
            receipt: "Receipt nr",
            resp_dt: "date of response",
            par1: "Parameter 1",
            par2: "Parameter 2",
            flags: "terminal advanced settings",
            resp1: "Basic discount",
            resp2: "Basic discount amount",
            resp3: "Card balance",
            resp4: "Accumulated points",
            resp5: "Bonus",
            resp6: "Additional discount",
            resp7: "Additional discount amount",
            resp8: "Secret balance",
            resp9: "Counter",
            type: "type",
            needPrint: "print receipt",
            needDisplay: "show on screen",
            formula: "formula",
            company: "Company",
            subcompany: "Place of sale",
            company_subname: "Place of sale",
            first_name: "Name",
            second_name: "Surname",
            recr_nr: "Reg.nr",
            initFormula: "Initialization formula",
            discount_n: "Additional discount",
            discount_0: "Basic discount",
            points_0: "Accumulated points",
            counter_n: "Counter",
            current_discount_0: "Calculated discount",
            amount_discount_n: "Add. discount amount",
            amount_discount_0: "Discount amount",
            debit_0: "Card balance",
            bonus_0: "Bonuses",
            refCard: "ref card",
            realDate: "real date",
            lang: "Language",
            state: "Card status"
        },
        menu: {
            tickets: "Tickets",
            tools: "Tools",
            structura: 'Company structure',
            transactions: "Transactions",
            info: "Summary",
            profiles: "Bulk messaging",
            cards: "List of cards",
            reports: "Reports",
            logs: "Transaction log",
            title: "E-Karte manager",
            logout: "Exit",
            carddetail: "Card details",
            posreports: "POS reports",
            actlog: "Activity log"
        },
        summary: {
            tt: {
                total: "Total transactions amount",
                avg: "Average transaction amount",
                count: "Count of transactions"
            },
            day: "Daily report",
            amount1: "Paid with cards",
            month: "Previous Month's Report"
        },
        card: {
            legend: {
                balance: "Card balance",
                reversal: "Cancellation of transactions",
                reversed: "Canceled transaction",
                purchase: ["Req. par1 > 0", "Payment by card", "Purchase registration", "Purchase registration", "Payment by card"],
                sell: ["Req. par2 > 0", "Card replenishment", "Payment by card", "Payment by card", "Purchase registration"],
                error: "Transaction error",
                info: "Card check",
                burn: "Burnable accumulation",
                display: "Answer at Terminal"
            },
            command: {
                "1100": "Card verification",
                "1200true": ["Req. par1 > 0", "Payment by card", "Purchase registration", "Purchase registration", "Payment by card"],
                "1200false": ["Req. par2 > 0", "Card replenishment", "Payment by card", "Payment by card", "Purchase registration"],
                "1300": "Canceling a transaction",
                "900": "Terminal report",
                "1000": "Terminal configuration"
            },
            acc: {
                operation: "Type of use",
                valid: "Valid to",
                used: "Used"
            },
            prof: {
                title: "Profile data",
                first_name: "Cardholder",
                second_name: "Promotion ID",
                reg_num: "Date of birth, e-mail, etc.",
                company_name: "Additional Info 1",
                company_subname: "Additional Info 2",
                additional: "Extended Info",
                bdays: "Important dates",
                sendsms: "Allow send sms",
                phone: "Phone",
                email: "E-mail",
                sendeml: "Allow send e-mails",
                add_date: "Add date"
            },
            stats: {
                recr_nr: "Last receipt no.",
                created: "Card adding date",
                validto: "Lifetime",
            },
            tooltip: {
                asc: "Sort Ascending",
                desc: "Sort Descending",
                logs: "Operator actions and answer on the terminal display",
                trans: "Card transactions",
                bilance: "Card balance after transaction",
                valid: "Card is expired",
                ok: "Card is active and in use",
                free: "Card is not activated",
                status1: "Card has been written off",
                status2: "Card is locked",
                bad_used_w: "A large count of errors can blocked card payment in the WEB store",
                bad_used_e: "Attention! Payment with a card in the WEB store may not be possible",
            },
            field: {
                sourceCard: "From",
                card2copy: "To",
                created: "Date and time",
                command: "Action",
                p2: ["Par2 summ", "Replenishment amount", "Payment by cust. card", "Payment by cust. card", "Purchase registartion"],
                p1: ["Par1 summ", "Payment amount", "Purchase registartion", "Purchase registartion", "Payment by cust. card"],
                resp3: "Card balance",
                message: "Answer at terminal",
                receipt: "Number of receipt",
                valid: "Lifetime",
                ocreated: "First use"
            },
            accbilance: "Card accumulation",
            turnover: "Card flow summ",
            currperc: "Calculated discount",
            filt_status: "Card activity",
            common: "General data",
            timeline: "Activity History",
            validfrom: "Activation date",
            validto: "Expiry date",
            receipt: "Transaction",
            to: "today",
            from: "activated",
            add_user_data: "Cardholder details",
            stat: "Card overview",
            last_used: "Last use",
            total_deals: "Total count of transactions",
            profile: "Card expiry date",
            accounts: "Card usage report",
            data: "Profile data",
            trans: "Transactions",
            logs: "Actions",
            until: "Card expiry date",
            debet: "Card balance",
            blockedByStatus: "Card is blocked",
            transCount: "Count of transactions",
            logCount: "Count of log records",
            bilance: "Card balance",
            status: {
                archived: "Removed",
                blocked: "Blocked",
                inactive: "Inactive",
                awaiting: "Awaiting",
                blockedByValid: "Invalid date"
            }
        },
        status: {
            "200": "Transaction",
            "201": "Transaction cancellation",
            "202": "Transaction canceled",
            "203": "Transaction automatically canceled",
            "100": "Running",
            "500": "Burnable accumulation",
            "1": "Removed",
            "2": "Locked",
        },
        report: {
            title: {
                cards: "Cards list",
                trans: "Transactions list",
                logs: "Log",
            },
            title1: "Basic filtr parameters",
            title2: "Additional filtr parameters",
            title3: "Append additional info",
            grp: {
                terminal: "Group by terminals",
                shop: "Group by place of sales"
            },
            params: {
                from: "Report start date",
                to: "Report end date",
                term: "Terminal",
                scomp: "Place of sale",
                udata: "Customer data",
                edata: "Extended data",
                sysId: "Card type",
                amt: "Selection filter",
                card: "Card",
                terminal: "Terminal",
                company: "Company",
                subcompany: "Place of sale",
                operation: "Type of use",
                first_name: "Name",
                second_name: "Surname"
            },
            tt: {
                actions: "Please select the report receive type",
                sorted: "Report image code, example @1",
            },
            amt: {
                all: "All transactions",
                amt1: "Card payments only",
                amt2: "Card replenishment only"
            },
            amt1: "amy1",
            amt2: "amt2",
            udata: "Add Cardholder Info",
            edata: "Add transactions additional information",
            types: "Card validity",
            cards: "List of cards",
            showZero: "Filter by balance",
            created: "Report Creation Date"
        },
        msg: {
            pin: {
                ok: "Card PIN is changed",
                fail: "Card PIN changing is failed"
            },
            valid: {
                ok: "Valid date is changed",
                fail: "Valid date changing is failed"
            },
            status: {
                ok: "Status is changed",
                fail: "Status changing is failed"
            },
            insert: {
                ok: "Record is created",
            },
            delete: {
                ok: "Record is deleted",
            },
            update: {
                ok: "Record is updated",
            },
        },
        error: {
            length: "Length is wrong",
            login: "Access with such enter data is not possible! Please check!",
            required: "This field is required",
            days2trigger: "Value from 0 to 7",
            sendat: "Time in format 09:00",
            existsbin: "The BIN is exists", 
            sendmessage: "Message length from 3 to 1071"
        },
        byLog: {
            true: "log",
            false: "transactions",
        },
        sortDesc: {
            true: "in descending order",
            false: "ascending order",
        },
        picker: {
            today: "today",
            yesterday: "yesterday",
            currentWeek: "curr.week",
            currentMonth: "curr.month",
            previousMonth: "prev.month",
            previousWeek: "last week",
            fromPreviousMonth: "from lst mon",
            fromStartYear: "curr.year"
        },
        command: {
            '1100': "Info",
            '1200': "Transaction",
            '1300': "Reversal"
        },
        recStatus: [{
                "value": 100,
                "text": "Active"
            },
            {
                "value": 2,
                "text": "Blocked"
            },
            {
                "value": 1,
                "text": "Removed"
            },
        ],
        help: {
            func: "<b>User functions</b>",
            welcome: "Welcome to the updated project of the website E-Card Manager",
            home: {
                searchByCard: "To search for information about the card (customer profile, usage history), as well as the card to extend the validity period, please enter the card number",
                searchByClient: "To search for a lost customer card, enter any information from the cardholder's profile",
                searchByTrans: "To search for a gift card for sale, enter the replenishment amount, select the point of sale and date of sale"
            },
            menu: {
                structura: "Company structure and card types",
                cards: "List of cards. Card usage and cardholder's information",
                transactions: "Information on card transactions",
                info: "Summary of today's and previous month's transactions and errors",
                home: "Return to start page",
                reports: "Report Templates",
                logs: "Activity and Event Log",
                posreports: "POS reports",
                profiles: "Formation of a target group for distribution",
                tickets: "Tickets system"
            },
            intro: "<p>Project 'E-Card manager' provides electronic gift and loyalty card activity statistics and system control</p>" +
                "<p><b>What's new:</b></p><p> We have fundamentally improved the methods and functions for working with large amounts of data, adding data export" +
                "and for your convenience we have added the possibility to export the data to MS Excel for further analysis. </p> <p> To make the work easier, we have added" +
                "start page most popular features </p> <p> If you have any questions or concerns about using this page, or have offer for improving it, or have noticed an error, please contact with our technical support by phone <a href = ' maito: +37167277233 '> 67277233 </a> or send a description of the issue / proposal " +
                "to email <a href='maito:help@idcs.lv'> help@idcs.lv </a> </p>"
        }
    },
    lv: {
        copyright: "© IDCS & E-KARTE ltd.",
        search: {
            amount2: "papildināšanas summa",
            system: "meklēt pēc karšu veida",
            companies: "meklēt uzņēmuma struktūrā",
            subcompanies: "izvelēties filiāli",
            operation: "izvelēties karšu izmantošanas veidu",
            terminal: "meklēt pēc termināla",
            card: "meklēt karti",
            pattern: "meklēt pēc kartes vai īpašnieka datiem",
            byCard: "meklēt pēc kartes numura",
            all: "Visi",
            byPattern: "meklēt pēc kartes īpašnieka datiem"
        },
        title: {
            login: "Autorizācija",
            main: "E-Karte manager",
            print: "Parametri datu pieprasījumam",
            card_pin: "WEB PIN maiņa",
            status_card: "Kartes statusa maiņa",
            card_copy: "Klienta datu kopēšana",
            extend_card: "Derīguma termiņa maiņa",
            smsAuth: "IDCS SMS CENTRS autorizācija"
        },
        login: {
            domain: "Partnera ID",
            login: "Lietotājs",
            pass: "Parole"
        },
        dialog: {
            confirm: "Ieraksta dzēšana",
            delete: "Vai Jūs esat pārliecināts, ka vēlaties dzēst ierakstu?",
            aconfirm: "Apstiprināt",
            tchangettl: "Darījuma statusa maiņa",
            tchangeqst: "Apstipriniet darījuma statusa maiņu:",
            tconfirm: "Nodzēst kļūdas ?",
        },
        button: {
            smsauth: "Pieslēgties",
            login: "Pieslēgties",
            apply: "Pielietot",
            save: "Saglabāt",
            delete: "Dzēst",
            add: "Pievienot",
            search: "Meklēt",
            cancel: "Atcelt",
            reset: "atcelt",
            extend: "derīguma termiņš",
            block: "statuss",
            edit: "mainīt",
            ok: "Apstiprināt",
            clone: "Dublēt",
            switch_group: "Mainīt grupu",
            download: "saņemt"
        },
        cardtypes: {
            all: "visi",
            valid: "derīgās",
            invalid: "nederīgās"
        },
        actlog: {
            actions: ["", "Derīguma termiņa maiņa", "Statusa maiņa", "PIN maiņa", "Kartes kopēšana", "Maiņa", "Dzēšana", "Izveidošana", "Pievienošana", "Nobloķēšana", "Ielogošana"],
            group: "Lietotāju grupa",
            user: "Lietotājs",
            action: "Darbība",
            idx: "Ieraksta ID",
            type: "Ieraksta veids",
            data: "Pieprasījuma dati",
            comment: "Komentārs",
            sys_data: "Papildus",
            request: "URI"
        },
        rules: {
            read: "Lasīt",
            create: "Taisīt jaunu",
            update: "Mainīt",
            delete: "Dzēst",
            menu: "Augšējās izvēlnes piekļuve",
            functions: "Piekļuves ierobežošana konkrētām funkcijām",
            records: "Detalizēta piekļuves uzstādīšana",
            profiles_r: "Izsūtīšanas (menu)",
            struct_r: "Struktūra izvelnē (menu)",
            struct_m: "Uzņēmumu struktūra",
            struct_s: "Pieslēgtas karšu tipu struktūra",
            struct_l: "Struktūra filtriem",
            summary_r: "Kopsavilkums (menu)",
            trans_r: "Darījumi (menu)",
            cards_r: "Kartes (menu)",
            actlog_r: "Lietotāju darījumu žurnāls",
            report_r: "Atskaites (menu)",
            stats_r: "Grāfiķi (menu)",
            log_r: "Darījumu žurnāls (menu)",
            utils_r: "Uzstādījumi (menu)",
            cardDets_r: "Karte detalizēti (menu)",
            info_r: "Starta lapa (menu)",
            export_r: "Eksports attalinātām lietotājām",
            remote_r: "Pikļuve attalinātam lietotājām (programmam)",
            fstat_w: "Statusa maiņа",
            fpin_r: "Lasīt PIN",
            fpin_w: "Mainīt PIN",
            fcopy_t: "Klienta datu kopēšana",
            posreport_r: "POS atskaites (menu)",
            fvalid_w: "Derīguma termiņa maiņa",
            fmode_s: "Interfeisu on-line maiņa",
            fcused_y: "Clear card bad used",
        },
        rec_types: {
            CardRecord: "Karte",
            CardDetailRecord: "Kartes stāvoklis",
            CompanyRecord: "Uzņemums",
            SubCompanyRecord: "Filiāle",
            TerminalRecord: "Termināls",
            TransactionRecord: "Darījums",
            TerminalDetailRecord: "Kartes veida pieslēgšana",
            SystemDetailRecord: "Kartes izmantošanas veids",
            SystemRecord: "Kartes veids",
            UserRecord: "Lietotājs",
            LogRecord: "Žurnāls",
            UserGroupRecord: "Lietotāju grupas",
            ReportRecord: "Atskaite",
            FrameRecord: "Freims",
            ErrorRecord: "Ziņojumu rediģēšana"
        },
        merch: {
            top: "Pirmie klienti",
            dayplus0: "ŠODIEN",
            dayplus1: "RĪTDIEN",
            dayplus2: "PARĪTDIEN",
            total: "Ziņas kopā",
            info1: "Izvēlēties klientu mērķauditoriju",
            info2: "Saņēmēju izvēlnes papildus parametri",
            info3: "Norādiet ziņojuma saņēmējus",
            info4: "Sastādiet ziņojuma tekstu",
            info5: "Pārbaudiet ziņojuma pareizību",
            info6: "Ieplānojiet izsūtīšanu",
            phonefph: "Izvēlieties tālruņa lauku",
            phonef: "Tālruņa lauks",
            smsph: "Ievadiet ziņojuma tekstu, izmantojiet personas mainīgos datus",
            nonamedays: "Jāizvēlas vienu vai vairākas dienas meklēšanai",
            nophones: "Ieraksti ar korektu tālruņa numuru nav atrasti",
            nomsgtext: "Lai turpinātu, ievadiet ziņojuma tekstu",
            phfounded: "Atrasti {count} korekti tālruņa numuri",
            selclients: "Noradīti {sels} ieraksti no {total}",
            statmsg: "Izsūtīt {count} sms ziņojumu priekš {target} saņēmējiem",
            schedtypes: [{
                    text: "Izsūtīt tūlīt",
                    title: "Izsūtīt tūlīt",
                    value: "1",
                    icon: "mdi-send-check"
                },
                {
                    text: "Ieplānot izsūtīšanu uz noteikto laiku",
                    title: "Ieplānot",
                    value: "2",
                    icon: "mdi-send-clock"
                },
                {
                    text: "Ievietot gaidīšanai IDCS SMS centrā un nosūtīt vēlāk ",
                    title: "Ievietošana gaidīšanai",
                    value: "3",
                    icon: "mdi-send"
                },
            ],
            state: "Stāvoklis",
            count: "SMS skaits",
            send2sms: "Ievietot IDCS SMS Centrā",
            message: "Ziņojuma teksts",
            noclients: "Saņēmēji nav izvēlēti",
            StaticQueries: "Vienreizēja Izsūtīšana",
            Schedule: "Automātiskā Izsūtīšana",
            schedules: [{
                text: "Dzimšanas diena",
                value: 0
            }, {
                text: "Vārda diena",
                value: 1
            }, {
                text: "Dzēšama summa",
                value: 2
            }],
            steps: [{
                text: "Saņēmēju izvēle",
                value: 1
            }, {
                text: "Filtrs",
                value: 2
            }, {
                text: "Izvēles rezultāts",
                value: 3
            }, {
                text: "Ziņojums",
                value: 4
            }, {
                text: "Pārbaude",
                value: 5
            }, {
                text: "Izsūtīšana",
                value: 6
            }],
            cltypes: [{
                text: "SMS",
                value: 0
            }, {
                text: "E-mail",
                value: 1
            }],
            days: [{
                    text: "Izsūtīšana konkrētā dienā",
                    value: 0
                },
                {
                    text: "Izsūtīšana 1 dienu pirms",
                    value: 1
                },
                {
                    text: "Izsūtīšana 2 dienas pirms",
                    value: 2
                },
                {
                    text: "Izsūtīšana 3 dienas pirms",
                    value: 3
                },
                {
                    text: "Izsūtīšana 4 dienas pirms",
                    value: 4
                },
                {
                    text: "Izsūtīšana 5 dienas pirms",
                    value: 5
                },
                {
                    text: "Izsūtīšana 6 dienas pirms",
                    value: 6
                },
                {
                    text: "Izsūtīšana nedēļu pirms",
                    value: 7
                },
                {
                    text: "Izsūtīšana mēnesi pirms",
                    value: 30
                }
            ],

            // msgcheck: "Check status",
            // start_unset: "Task unscheduled. Will be schedule at SMS center.",
            smsname: "Izsūtnes nosaukums",
            sendTitle: "Ievadiet izsūtnes nosaukumu",
            // from: "From date",
            // type: "Type of client",
            // types: [{ text: "SMS", value: 0 }, { text: "E-mail", value: 1 }],
            // select: "Selection method",
            selects: [{
                    text: "Visi klienti",
                    value: 0,
                    desc: "Visu klientu saraksts",
                    sort: "Atlasīti pēc kartes lietošanas biežuma"
                },
                {
                    text: "Pēc klientu aktivitātes",
                    value: 4,
                    desc: "Aktīvie klienti par periodu",
                    sort: "Atlasīti pēc kartes pēdējās lietošanas datuma"
                },
                {
                    text: "Pēc klientu neaktivitātes",
                    value: 6,
                    desc: "Neaktīvie klienti par periodu",
                    sort: "Atlasīti pēc kartes pēdējās lietošanas datuma"
                },
                {
                    text: "Pēc lielākās apmaksas summas",
                    value: 1,
                    desc: "Klienti un viņu lielākās apmaksas summas par periodu",
                    sort: "Atlase pēc apmaksas summām"
                },
                {
                    text: "Pēc lielākā pirkuma",
                    value: 5,
                    desc: "Klienti un viņu lielākie pirkumumi par periodu",
                    sort: "Atlase pēc pirkuma summām"
                },
                {
                    text: "Pēc pirkumu skaita",
                    value: 7,
                    desc: "Klienti un viņu pirkumu skaits par periodu",
                    sort: "Atlase pēc pirkumu skaita"
                },
                {
                    text: "Pēc atlikuma kartēs",
                    value: 2,
                    desc: "Klienti un viņu atlikumi kartē",
                    sort: "Atlase pēc atlikumu lieluma"
                },
                {
                    text: "Pēc kartes atlaides",
                    value: 3,
                    desc: "Klienti un viņu atlaides kartē",
                    sort: "Atlase pēc atlaides lieluma"
                },
                {
                    text: "Pēc vārda dienas",
                    value: 8,
                    desc: "Klienti, kuriem tuvojas vārda diena",
                    sort: "Atlase pēc kartes numura"
                },
                {
                    text: "Pēc dzimšanas dienas",
                    value: 9,
                    desc: "Klienti, kuriem tuvojas dzimšanas diena",
                    sort: "Atlase pēc kartes numura"
                },
                {
                    text: "Pēc atlaides līmeņa",
                    value: 10,
                    desc: "Klienti, kuriem tūvojas nākošais atlaides līmenis",
                    sort: "Atlase pēc kartes apgrozījuma"
                },
            ],
            customval: ["Izveidošanas datums", "Pirkuma summa", "Atlikums kartē", "Atlaide kartē", "Pedējais darījums", "Reģistrācijas summa", "Pedējā izmantošana", "Darījumu skaits", "", "", "Kartes apgrozījums"],
            tops: [{
                text: "Visi",
                value: 0
            }, {
                text: "TOP 5",
                value: 1
            }, {
                text: "TOP 25",
                value: 2
            }, {
                text: "TOP 50",
                value: 3
            }, {
                text: "Brīva izvēle",
                value: 4
            }],
            nameday: [{
                text: "Šodien",
                value: 0
            }, {
                text: "Rītdien",
                value: 1
            }, {
                text: "Pārītdien",
                value: 2
            }, {
                text: "Tekošā nedēļa",
                value: 3
            }],

            dtitle: "Pārbaudei",
            f: {
                discamt: "Līdz nākošajam līmenim pietrūkst",
                discperc: "Nākošā līmeņa %",
                nameday: "Meklēšanas periods",
                txtnameday: "Norādiet ierobežojumus meklēšanai vārda dienām",
                phnameday: "Vārda dienas",
                txtperiod: "Notikuma laika ierobežojumi",
                txtsubcompany: "Ierobežojumi pēc filiālēm",
                top: "Saņēmēju skaits",
                txttop: "Saņēmēju skaita ierobežojums",
                next: "Nākošā notikuma pārbaude",
                range: "Periods",
                phrange: "Par visu laiku",
                cltype: "Izsūtīšanas veids",
                phsubcompanies: "Visas filiāles",
                schedule: "Notikumu veids",
                name: "Izsūtīšanas nosaukums",
                phname: "Izsūtīšanas nosaukums, ar kuru tiks reģistrēta IDCS SMS Centrā",
                trigger_type: "Notikuma veids",
                message: "Ziņojums",
                phmessage: "Ievadiet ziņojuma tekstu",
                created: "Izveidots",
                lastrun: "Pedējā notikuma datums",
                lastcode: "Pedējā notikuma kods",
                total: "Ziņojumi kopā",
                days2trigger: "Pirmsizsūtīšana",
                sendat: "Izsūtīšanas laiks"
            }
        },
        admin: {
            smsdisclevels: "Atlaižu līmeņu apraksts. Formāts (Apgrozījums-summa līdz nākošājam līmenim/Atlaižu procents). Piemērs (100-10/10,300-10/15,500-10/15)",
            group_cust: "Piekļūves grupas papildus parametri",
            freecards: "Neaktivizētas kartes",
            fwidth: "Freima plašums",
            fheight: "Freima augums",
            actions: "Akcījas",
            fcardlen: "Kartes numura precīzs simbolu skaits",
            deflang: "Freima valoda pēc noklusēšanas",
            frames: "Freimu saraksts",
            usersupp: "Piekļuves pārvaldība",
            errors: "Kļūdas",
            functions: "Papildus iespējas",
            reports: "Atskaites",
            users: "Lietotāji",
            bins: "BINu saraksts",
            groups: "Lietotāju grupas",
            errorId: "kods",
            newcmsonly: "Atļaut tikai CMS.E-Karte.lv",
            iface: "Noformējuma veids",
            def_message: "Globālais ziņas tulkojums",
            errorid: "Ziņojuma ID",
            rules: "Pieejas parametri",
            l_editor_type: "Klientu anketu tips",
            editor_type: [
                "Parastais",
                "Marketinga datu tips",
            ],
            interface_type: [
                "Administratīva",
                "Dāvanu kartes",
                "Klientu kartes SJZ",
                "Kl.kartes ar dzēšanu GRD",
                "Reverse kl. kartes",
            ],
            frame_type: [
                "Dāvanu kartes",
                "Klientu kartes SJZ",
                "Kl.kartes ar dzēšanu GRD",
                "Reverse kl. kartes",
            ],
            // interface_type: {
            //     common: "Visparīgs",
            //     debet: "Dāvanu kartes",
            //     client: "Klientu kartes"
            // }
        },
        trans: {
            all_data: "rādīt labojumus",
            tooltip: {
                count: "Darījumu skaits par izvēlētu periodu"
            }
        },
        ticket: {
            title: "Pieprasījums",
            type: "Pieprasījuma forma",
            description: "Pieprasījuma apraksts",
            closedat: "Pabeigšanas datums",
            resume: "Atbildes piezīme",
            domain: "Partneris",
            search_l: "Meklēšana",
            status_l: "Pieprasījumu status",
            status_ph: "Visi pieprasījumi",
            search: "Ievadiet tekstu",
            sender: "Lietotājs",
            types: [{
                text: "Brīvā formā",
                value: 0,
                description: ""
            }, {
                text: "Naudas pārlikšana",
                value: 1,
                description: "Lūdzu pārlikt naudu [___] Eur apmērā no kartes nr.[___] uz karti nr.[___]"
            }, {
                text: "Anulēt darījumu",
                value: 2,
                description: "Lūdzu anulēt darījumu ar karti nr.[___] par summu [___] Eur, kurš bija veikts veikalā/terminālī [___], datums un laiks [___]"
            }, {
                text: "Anulēt darījumu un veikt jaunu",
                value: 3,
                description: "Lūdzu anulēt darījumu ar karti nr.[___] par summu [___] Eur, kurš bija veikts veikalā/terminālī [___], datums un laiks [___] un veikt jaunu darjumu par summu [___] Eur"
            }, {
                text: "Pieprasīt WEB PIN kodu",
                value: 4,
                description: "Lūdzu nosūtiet kartes nr.[___] WEB PIN kodu"
            }],
            status: [{
                text: "Atlikts",
                value: 0
            }, {
                text: "Gaida",
                value: 1
            }, {
                text: "Apstrādē",
                value: 2
            }, {
                text: "Pabeigts",
                value: 3
            }, {
                text: "Atcelts",
                value: 4
            }],
            msg: {
                completed:"Pieprasījums ir pabeigts",
                canceled: "Pieprasījums ir atcelts",
                deleted: "Pieprasījums ir dzēsts",
                saved: "Pieprasījums ir saglabāts",
                error: "Kļūda"
            },
            btn:{
                complete:"Pabeigt pieprasījumu",
                save:"Saglabāt kā nepabeigtu",
                delete:"Dzēst",
                todraft: "Atgriezt uz pārstrādi",
                cancel:"Atcelt pieprasījumu",
                start:"Sūtīt uz apstrādi"
            }
        },
        label: {
            for: "priekš",
            hidetext: "Tikai ikoniņas",
            modified: "Atjaunots",
            not_found: "Nekas nav atrasts",
            placeholder: "Ievadiet datus",
            toDisplay: "uz ekrāna",
            toXml: "failā (xml)",
            toCsv: "failā (csv)",
            toExcel: "failā (excel)",
            includeAll: "Pievienot visus laukus",
            excludeAll: "Atslēgt visus laukus",
            deals: "Darījuma numurs",
            rowPerPage: "Ierakstu skaits lapā",
            nodata: "Pēc Jūsu pieprasījuma nekas nav atrasts"
        },
        field: {
            smsuser: "Lietotājs",
            smspass: "Parole",
            params: "Parametri",
            frametype: "Atbildes formāts",
            errors: "Kļūdu skaits",
            hash: "Freim ID",
            amount2Eu: ["Par2 summa", "DK papildināšanas summa", "Apmaksa ar kl. karti", "Apmaksa ar kl. karti", "Pirkuma reģistrācija"],
            amount1Eu: ["Par1 summa", "Apmaksas summa ar DK", "Pirkuma reģistrācija", "Pirkuma reģistrācija", "Apmaksa ar kl. karti"],
            amount2: ["Par2 summa", "DK papildināšanas summa", "Apmaksa ar kl. karti", "Apmaksa ar kl. karti", "Pirkuma reģistrācija"],
            amount1: ["Par1 summa", "Apmaksas summa ar DK", "Pirkuma reģistrācija", "Pirkuma reģistrācija", "Apmaksa ar kl. karti"],
            totalAmount1Eu: ["Kopā par1 summa", "Kopā DK papildināšanas", "Registrēto pirkumu summa", "Registrēto pirkumu summa", "Apmaksu summa ar kl.kartēm"],
            totalAmount2Eu: ["Kopā par1 summa", "Kopā apmaksas ar DK", "Apmaksu summa ar kl.kartēm", "Apmaksu summa ar kl.kartēm", "Registrēto pirkumu summa"],
            d_debet: ["Kartes atlikums", "Kartes atlikums", "Kartes atlikums", "Kartes atlikums", "Kartes atlikums"],
            current_discount: "Tēkošā atlaide",
            next_month: "Dzešāmie uzkrājumi",
            amount_discount: "Kartes apgrozījums",
            amount_debit: "Kartes atlikums",
            bonus_0: "Bonusi",
            debit_n: "Uzkrāta summa",
            reversed: "Anulēšanas datums",
            counter: "Darījumu skaits",
            carddetail: "Kartes nr.",
            CardDetail: "Kartes nr.",
            terminaldetail: "Termināla ID",
            TerminalDetail: "Termināla ID",
            id: "Termināla ID",
            Terminal: "Termināla ID",
            Company: "Uzņēmums",
            companyName: "Filiāle",
            SubCompany: "Filiāle",
            companySubName: "Filiāle",
            debet_nEu: "Uzkrājumu summa",
            debet_0Eu: "Atlikums kartē",
            amountDebetEu: "Atlikums kartē",
            debetBilance: "Atlikums kartē",
            lastUsed: "Pēdējā izmantošana",
            used: "Darījumu skaits",
            validc: "Kartes dzīvildze",
            lastModified: "Pēdējās izmaiņas",
            System: "Karšu veids",
            totalTrans: "Darījumu skaits",
            cmd: "Komanda",
            cmd900x: "X-atskaite",
            cmd900z: "Z-atskaite",
            cmd1000: "BIN",
            cmd1100: "INFO",
            cmd1200: "TRANS",
            cmd1300: "ROLL",
            cmd1200p: "PRN trans",
            cmd1300p: "PRN roll",
            errorResp: "error resp",
            errorCmd: "error cmd",
            totalc: "total cmd",
            totalp: "total prn",
            firstName: "Klientu informācija 1",
            secondName: "Klientu informācija 2",
            m1: "Jan",
            m2: "Feb",
            m3: "Mar",
            m4: "Apr",
            m5: "Mai",
            m6: "Jūn",
            m7: "Jūl",
            m8: "Avg",
            m9: "Sep",
            m10: "Okt",
            m11: "Nov",
            m12: "Dec",
            nextMonth: "Dzēšamie uzkrājumi",
            regNumber: "Klientu informācija 3",
            day: "Mēneša datums",
            totals: "Summas lauki",
            sysdata: "Sistēmas parametri",
            fields: "Atskaites lauki",
            filtrs: "Datu filtrēšana (novēcojās)",
            repid: "Atskaites iekšējas kods",
            inputPars: "Atskaites ieiejas parametri",
            nameId: "Tulkojumu kods",
            sorted: "Atskaites bildes kods",
            errorId: "Tulkojumu kods",
            password: "Parole",
            created_: "Izveidošanas datums",
            rec_nr: "Čeka nr.",
            c_company_name: "Klientu informācija 3",
            c_company_subname: "Klientu informācija 4",
            reg_num: "Klientu informācija 5",
            last_name: "Klientu informācija 2",
            subcompany_name: "Klientu informācija 4",
            company_name: "Klientu informācija 3",
            regnr: "Klientu informācija 5",
            additional: "Papildus info.",
            last_trans: "Pēdējas darijuma datums",
            ovalid: "Derīgs līdz",
            validcd: "Derīgs līdz",
            user_group: "Grupa",
            pattern: "Šablons",
            pos: "#",
            pin: "WEB PIN",
            bad_used: "Kļūdu skaits",
            last_used: "Pēdējā izmantošana",
            created: "Izveidots",
            dt: "Datums un laiks",
            req_dt: "Pieprasījums izveidots",
            last_modified: "Pēdējās izmaiņas",
            modified: "Pēdējās izmaiņas",
            req_command: "Komandas kods",
            code: "Atbildes kods",
            message: "Atbilde terminālā",
            ip: "IP adrese",
            name: "Nosaukums",
            card: "Karte",
            req_ms: "Karte",
            status: "Status",
            dbtMinus: "Apmaksātā summa",
            dbtPlus: "Papildināšanas summa",
            repNo: "Ped.Z-Atskaites Nr.",
            lastResponseId: "Atbildes ID",
            lastRequestId: "Pieprasījuma ID",
            operation: "Izmantošanas veids",
            Operation: "Izmantošanas veids",
            terminal: "Termināls",
            req_terminal: "Termināls",
            system: "Kartes veids",
            operNrDef: "Operācija pēc noklusējuma",
            bin: "BINs",
            justTrans: "Reģistrācija",
            needOperNr: "Ir nepieciešams ievadīt operācijas nr.",
            debetIn: "Papildināšanas iespēja",
            extset: "Papildus parametri",
            pinFlag: "PIN uzstādījumi",
            checkSumFormula: "Kartes pārbaudes formula",
            valid: "Derīgs līdz",
            operNr: "oper Nr",
            reversal: "anulēšanas iespēja",
            req_id: "pieprasījuma id",
            resp_id: "atbildes id",
            receipt: "Čeka numurs",
            resp_dt: "atbildes datums",
            par1: "1.parametrs",
            par2: "2.parametrs",
            flags: "termināla papildus uzstādījumi",
            resp1: "Bāzes atlaide",
            resp2: "Bāzes atlaides summa",
            resp3: "Kartes atlikums",
            resp4: "Uzkrātie punkti",
            resp5: "Bonus",
            resp6: "Papildus atlaide",
            resp7: "Papildus atlaides summa",
            resp8: "Slepenais atlikums",
            resp9: "Skaitītājs",
            type: "veids",
            needPrint: "drukāt čeku",
            needDisplay: "rādīt uz ekrāna",
            formula: "Darbības formula",
            company: "Uzņēmums",
            subcompany: "Filiāle",
            company_subname: "Filiāle",
            first_name: "Klientu informācija 1",
            second_name: "Klientu informācija 2",
            recr_nr: "Reģ.nr",
            initFormula: "Inicializācijas formula",
            discount_n: "Papildus atlaide",
            discount_0: "Bāzes atlaide",
            points_0: "Uzkrātie punkti",
            counter_n: "Skaitītājs",
            current_discount_0: "Atlaide",
            amount_discount_n: "Papildus atlaides summa",
            amount_discount_0: "Atlaides summa",
            debit_0: "Kartes atlikums",
            refCard: "Mātes karte",
            realDate: "Darījuma datums",
            lang: "Valoda",
            state: "Kartes status"
        },
        menu: {
            tools: "Sistēmas funkcijas",
            structura: 'Uzņēmuma struktūra',
            transactions: "Darījumi",
            info: "Kopsavilkums",
            cards: "Karšu saraksts",
            reports: "Atskaites",
            logs: "Darījumu žurnāls",
            title: "E-Karte manager",
            logout: "Izeja",
            profiles: "Izsūtīšanas",
            actlog: "Lietotāju darījumu žurnāls",
            posreports: "POS atskaites",
            tickets: "Pieprasījumi",
            carddetail: "Detalizēti par karti",
        },
        summary: {
            tt: {
                total: "Kopējā darījumu summa",
                avg: "Vidējā darījuma summa",
                count: "Darījumu skaits"
            },
            day: "Dienas pārskats",
            amount1: "Apmaksāts ar kartēm",
            month: "Iepriekšējā mēneša pārskats"
        },
        tooltip: {
            needDisplay: "Noņemiet ķeksiti, lai rādītu mobilāja terminalī",
            mobileParam: "Izmantojamais parametrs darījumā ",
        },
        card: {
            legend: {
                bilance: "Kartes atlikums",
                reversal: "Darījumu anulēšana",
                reversed: "Anulētais darījums",
                purchase: ["Req. par1 > 0", "Apmaksas summa ar DK", "Pirkumu registrācija", "Pirkumu registrācija", "Apmaksa ar kl. karti"],
                sell: ["Req. par2 > 0", "DK papildināšanas summa", "Apmaksa ar kl. karti", "Apmaksa ar kl. karti", "Pirkumu registrācija"],
                error: "Darījuma kļūda",
                burn: "Uzkrājumu dzēšana",
                info: "Kartes pārbaude",
                display: "Atbilde terminālā"
            },
            command: {
                "1100": "Kartes pārbaude",
                "1200true": ["Req. par1 > 0", "Apmaksas summa ar DK", "Pirkumu registrācija", "Pirkumu registrācija", "Apmaksa ar kl. karti"],
                "1200false": ["Req. par2 > 0", "DK papildināšanas summa", "Apmaksa ar kl. karti", "Apmaksa ar kl. karti", "Pirkumu registrācija"],
                "1300": "Darījuma anulēšana",
                "900": "Termināla atskaite",
                "1000": "Termināla uzstādījumi"
            },
            acc: {
                operation: "Izmantošanas veids",
                valid: "Derīga līdz",
                used: "Izmantošanas reizes"
            },
            prof: {
                phone: "Tālruņa numurs",
                email: "E-pasts",
                bdays: "Īpašie datumi",
                title: "Anketas dati",
                first_name: "Kartes īpašnieks",
                second_name: "Akciju ID",
                reg_num: "Dzimšanas datums, e-pasts u.c.",
                company_name: "Papildus Info 1",
                company_subname: "Papildus Info 2",
                additional: "Paplašināts Info"
            },
            stats: {
                recr_nr: "Pēdējā čeka nr.",
                created: "Kartes pieslēgšanas datums",
                validto: "Kartes dzīvildze",
            },
            tooltip: {
                asc: "Kārtot augošā secībā",
                desc: "Kārtot dilstošā secībā",
                logs: "Operātora darbības un atbildes terminālā",
                trans: "Kartes darījumi",
                bilance: "Kartes atlikums pēc darījuma",
                valid: "Karte ir bloķēta pēc derīguma termiņā",
                ok: "Karte ir aktīva un lietošanā",
                free: "Karte nav aktivizēta",
                status1: "Karte ir norakstīta",
                status2: "Karte ir bloķēta",
                bad_used_w: "Liels kļūdu daudzums var traucēt apmaksu ar karti WEB veikalā",
                bad_used_e: "Uzmanību! Iespējams, ka apmaksa ar karti WEB veikalā nav iespējama",
            },
            field: {
                sourceCard: "Kopējamā karte",
                card2copy: "Jaunā karte",
                created: "Datums un laiks",
                command: "Darbība",
                p2: ["Par2 summa", "DK papildināšanas summa", "Apmaksa ar kl. karti", "Apmaksa ar kl. karti", "Pirkuma reģistrācija"],
                p1: ["Par1 summa", "Apmaksas summa ar DK", "Pirkuma reģistrācija", "Pirkuma reģistrācija", "Apmaksa ar kl. karti"],
                resp3: "Kartes atlikums",
                message: "Atbilde terminālā",
                receipt: "Darījumu skaits",
                ocreated: "Pirmā izmantošana",
                valid: "Kartes dzīvildze"
            },
            accbilance: "Kartes uzkrājums",
            turnover: "Kartes apgrozījums",
            currperc: "Aprēķīnātā atlaide",
            filt_status: "Kartes aktivitātes status",
            common: "Vispārīgi dati",
            timeline: "Darbību vēsture",
            validfrom: "Aktivizēšanas datums",
            validto: "Derīguma termiņš",
            valid: "derīga līdz",
            receipt: "Darījums",
            to: "šodien",
            from: "aktivizēta",
            add_user_data: "Kartes īpašnieka dati",
            stat: "Kartes pārskats",
            last_used: "Pēdējā izmantošana",
            total_deals: "Kopējais darījumu skaits",
            profile: "Kartes derīguma termiņš",
            accounts: "Kartes izmantošanas pārskats",
            data: "Anketas dati",
            trans: "Darījumu saraksts",
            logs: "Darbību saraksts",
            until: "Derīguma atlikušais laiks",
            debet: "Kartes atlikums",
            bilance: "Kartes atlikums",
            transCount: "Darījumu skaits",
            logCount: "Ierakstu skaits žurnālā",
            status: {
                archived: "Norakstīta",
                blocked: "Bloķēta",
                inactive: "Nav aktivizēta",
                awaiting: "Nav aktivizēta",
                blockedByValid: "Nederīgs termiņš"
            }
        },
        status: {
            "200": "Darījums",
            "201": "Darījuma anulēšana",
            "202": "Darījums anulēts",
            "203": "Darījums automātiski anulēts",
            "100": "Darbojas",
            "500": "Uzkrājumu dzēšana",
            "1": "Norakstīta",
            "2": "Bloķēta",
        },
        showZeroTypes: {
            all: "Rādīt visi karšu atlikumi",
            exclude: "Rādīt kartes tikai ar atlikumiem",
            only: "Rādīt tikai kartes ar nulles atlikumiem"
        },
        report: {
            title: {
                cards: "Karšu saraksts",
                trans: "Darījumu saraksts",
                logs: "Žurnāls",
            },
            title1: "Bāzes filtra dati",
            title2: "Papildus filtra dati",
            title3: "Papildus informācijas pievienošana",
            grp: {
                terminal: "Apvienot pa termināliem",
                shop: "Apvienot pa filiāliem"
            },
            amt: {
                all: "Visi darījumi",
                amt1: "Tikai apmaksas ar kartēm",
                amt2: "Tikai karšu papildināšanas"
            },
            params: {
                from: "Atskaites sākuma datums",
                to: "Atskaites beiguma datums ",
                term: "Termināls",
                scomp: "Filiāle",
                udata: "Klientu dati",
                edata: "Darījumu papildus parametri",
                sysId: "Kartes veids",
                card: "Karte",
                amt: "Filtrs"
            },
            tt: {
                actions: "Lūdzu izvēlēties datu saņēmšanas veids",
                sorted: "Atskaites bildes kods, piemēram @1",
            },
            udata: "Pievienot kartes īpašnieka Info",
            edata: "Pievienot paplašinātu informāciju par darījumu",
            types: "Karšu derīgums",
            cards: "Karšu saraksts",
            created: "Atskaites izveidošanas datums",
            showZero: "Filtrs pēc karšu atlikumiem",
        },
        error: {
            lenght: "Nepareizs garums",
            login: "Pievienošanās ar tādiem datiem nav iespējama! Lūdzu, pārbaudiet datus!",
            required: "Šis lauks jāaizpilda obligāti"
        },
        byLog: {
            true: "žurnāls",
            false: "darījumi",
        },
        sortDesc: {
            true: "dilstošā secībā",
            false: "augošā secībā",
        },
        session: {
            title: "Uzmanību!",
            text: "Jūsu sesija drīz beigsies! Lai turpinātu, aizveriet šo logu!",
        },
        picker: {
            today: "šodien",
            yesterday: "vakar",
            currentWeek: "tek.nedēļa",
            currentMonth: "tek.mēnesis",
            previousMonth: "iepr.mēnesis",
            previousWeek: "iepr.nedēļa",
            fromPreviousMonth: "no iepr.mēneša",
            fromStartYear: "tek.gads"
        },
        command: {
            '1100': "Info",
            '1200': "Transaction",
            '1300': "Reversal"
        },
        msg: {
            clone: {
                ok: "Kartes dati ir veiksmīgi nokopēti",
                fail: "Neizdevās nokopēt dati"
            },
            pin: {
                ok: "Kartes PIN ir mainīts",
                fail: "Neizdevās mainīt kartes PIN"
            },
            valid: {
                ok: "Derīguma termiņš ir mainīts",
                fail: "Neizdevās mainīt kartes derīguma termiņu"
            },
            update: {
                ok: "Ieraksts ir mainīts",
                fail: "Neizdevās mainīt ieraksts"
            },
            status: {
                ok: "Kartes statuss ir mainīts",
                fail: "Neizdevās mainīt kartes statusu"
            }
        },
        recStatus: [{
                "value": 100,
                "text": "Darbojas"
            },
            {
                "value": 2,
                "text": "Bloķēta"
            },
            {
                "value": 1,
                "text": "Norakstīta"
            },
        ],
        help: {
            func: "<b>Lietotāja funkcijas :</b>",
            welcome: "Laipni lūdzam atjauninātajā projekta mājas lapā E-karte Manager",
            home: {
                searchByCard: "Lai meklētu informāciju par karti (klienta anketu, izmantošanas vēsturi), ka arī karte derīguma termiņa pagarināšanai ievadiet kartes numuru",
                searchByClient: "Lai meklētu nozaudētu klienta karti, ievadiet jebkuru informāciju no kartes īpašnieka anketas datiem",
                searchByTrans: "Lai meklētu pārdotu dāvanu karti, ievadiet papildināšanas summu, izvēlieties pārdošanas vietu un datumu"
            },
            menu: {
                posreports: "POS atskaites",
                structura: "Uzņēmuma struktūra un karšu veidi",
                cards: "Karšu saraksts. Informācija par kartes lietošanu un īpašnieku",
                transactions: "Informācija par darījumiem ar kartēm",
                info: "Kopsavilkums par šodienas un iepriekšējā mēneša darījumiem un kļūdam",
                home: "Atgriezties un sākumu",
                reports: "Atskaišu šabloni",
                profiles: "Klientu atlasīšana piedāvājumiem",
                logs: "Darbību un notikumu žurnāls",
                tickets: "Pieprasījumi"
            },
            intro: "<p> Projekts 'E-Karte manager' nodrošina elektronisko dāvanu un lojalitātes karšu darbības statistikas veidošanu un sistēmas kontroli" +
                "</p><p><b>Kas jauns:</b></p><p></p><p>Mēs esam pamatos uzlabojuši metodes un funkcijas darbam ar lieliem datu apjomiem, datu eksportu " +
                "un Jūsu ērtībām pievienojām iespēju datu ekspotēšanai uz MS Excel turpmākai analīzei.</p><p>Lai atvieglotu darbu, esam pievienojuši " +
                "sākuma logā pieprasītākās iespējas </p><p>Ja Jums rodas jautājumi vai neskaidrības par šīs lapas lietošanu, vai ir priekšlikumi tās uzlabošanai, vai esat pamanījuši kādu kļūdu, lūdzu, saziņieties ar mūsu tehniskās palīdzības dienestu pa telefonu <a href='maito:+37167277233'>67277233</a> vai atsūtiet problēmas/ priekšlikuma aprakstu " +
                "uz e-pastu <a href='maito:help@idcs.lv'>help@idcs.lv</a></p>"
        }
    },
    ru: {
        copyright: "© IDCS ltd.",
        search: {
            amount2: "сумма пополнения",
            system: "поиск в типах карт",
            companies: "поиск в структуре предприятия",
            subcompanies: "искать в филиалах",
            operation: "искать в операциях",
            terminal: "искать в терминалах",
            card: "искать в картах",
            pattern: "искать по фрагменту данных карты",
            byCard: "поиск по номеру карты",
            byPattern: "поиск по данным о владельце",
            all: "все",
            errorid: "Код ошибки"
        },
        title: {
            smsAuth: "Авторизация в IDCS SMS CENTRS",
            login: "Авторизация",
            main: "E-Karte manager",
            print: "Формирование данных для печати",
            card_pin: "Смена кода карты",
            status_card: "Смена статуса карты",
            extend_card: "Изменение срока годности",
            card_copy: "Копирование данных карты"
        },
        login: {
            domain: "Партнер",
            login: "Пользователь",
            pass: "Пароль"
        },
        dialog: {
            confirm: "Удаление записи",
            delete: "Вы уверены, что хотите удалить запись ?"
        },
        ticket: {
            title: "Заявкa",
            type: "Тип",
            description: "Описание",
            closedat: "Выполнено",
            resume: "Ответ исполнителя",
            domain: "Партнер",
            search_l: "Текст для поиска",
            search: "Введите текст для поиска",
            status_l: "Фильтр заявок по статусу",
            status_ph: "Все заявки",
            sender: "Пользователь",
            types: [{
                text: "Свободная форма",
                value: 0,
                description: ""
            }, {
                text: "Перенос средств",
                value: 1,
                description: "Перенести средства в размере [___] Eur с карты номер [___] на карту номер [___]"
            }, {
                text: "Отмена транзакции",
                value: 2,
                description: "Отменить транзакцию по карте [_______] на сумму [_____], которая произведена  на торговом месте/ на терминале [__________________] дата и время [____]"
            }, {
                text: "Отмена транзакции и новая транзакция",
                value: 3,
                description: "Отменить транзакцию по карте [_______] на сумму [_____], которая произведена  на торговом месте/ на терминале [__________________] дата и время [____]"
            }, {
                text: "Запросить ПИН код карты",
                value: 4,
                description: "Просим прислать WEB PIN карты номер [_____]"
            }],
            status: [{
                text: "Отложена",
                value: 0
            }, {
                text: "Ожидает",
                value: 1
            }, {
                text: "В обработке",
                value: 2
            }, {
                text: "Выполнена",
                value: 3
            }, {
                text: "Отменена",
                value: 4
            }],
            msg: {
                canceled: "Заявка отклонена",
                deleted: "Заявка удалена",
                saved: "Заявка сохранена",
                error: "Ошибка"
            },
            btn: {
                complete: "Выполнить",
                save: "Сохранить как незавершенное",
                delete: "Удалить",
                cancel: "Отменить заявку",
                todraft: "Отправить на доработку",
                start: "Отправить на обработку"
            }
        },

        button: {
            smsauth: "SMS Авторизация",
            login: "Войти",
            apply: "Применить",
            save: "Сохранить",
            delete: "Удалить",
            add: "Добавить",
            search: "Поиск",
            cancel: "Отменить",
            reset: "сброс",
            extend: "срок действия",
            block: "статус",
            edit: "изменить",
            ok: "Подтвердить",
            clone: "Копировать",
            download: "получить",
            switch_group: "Сменить группу",
        },
        cardtypes: {
            all: "все",
            valid: "действительные",
            invalid: "просроченные"
        },
        rec_types: {
            CardRecord: "Карта",
            CardDetailRecord: "Состояния карты",
            CompanyRecord: "Предприятие",
            SubCompanyRecord: "Филиал",
            TerminalRecord: "Терминал",
            TransactionRecord: "Сделка",
            TerminalDetailRecord: "Подключение типа карт",
            SystemDetailRecord: "Вид использования",
            SystemRecord: "Тип карты",
            UserRecord: "Пользователь",
            LogRecord: "Журнал",
            UserGroupRecord: "Группы пользователей",
            ReportRecord: "Отчет",
            FrameRecord: "Фрейм",
            ErrorRecord: "Редактирование кода сообщения"
        },
        actlog: {
            actions: ["", "Смена срока действия карты", "Смена статуса", "Смена PIN", "Копирование карты", "Изменение", "Удаление", "Создание", "Смена родителя", "Блокировка", "Подключение"],
            group: "Группа",
            user: "Пользователь",
            action: "Действие",
            idx: "ID",
            type: "Тип записи",
            data: "Данные",
            comment: "Комментарии",
            sys_data: "Дополнительно",
            request: "URI"
        },
        merch: {
            dayplus0: "СЕГОДНЯ",
            dayplus1: "ЗАВТРА",
            dayplus2: "ПОСЛЕЗАВТРА",
            total: "Всего сообщений",
            info1: "Выберите целевую аудиторию клиентов",
            info2: "Дополнительные параметры выбора получателей",
            info3: "Укажите получателей сообщения",
            info4: "Составьте текст сообщения",
            info5: "Проверьте правильность сообщений",
            info6: "Запланируйте отправку",
            phonefph: "Выберите поле с телефоном",
            phonef: "Поле с телефоном",
            smsph: "Введите текст сообщения, вставляйте персональные переменные, если необходимо",
            nonamedays: "Выберите хотя бы один день для поиска",
            nophones: "Не найдено записей с корректным телефоном",
            nomsgtext: "Необходимо ввести текст сообщения, что бы перейти к селдующему шагу",
            phfounded: "Найдено {count} корректных номеров телефонов",
            selclients: "Выбрано {sels} записей из {total}",
            statmsg: "Разослать {count} смс сообщений для {target} получателей",
            schedtypes: [{
                    text: "Отослать как можно быстрее",
                    title: "Отослать сейчас",
                    value: "1",
                    icon: "mdi-send-check"
                },
                {
                    text: "Запланировать рассылку на указанное время",
                    title: "Запланировать",
                    value: "2",
                    icon: "mdi-send-clock"
                },
                {
                    text: "Поместить в очередь IDCS SMS центра и отослать самостоятельно",
                    title: "В очередь",
                    value: "3",
                    icon: "mdi-send"
                },
            ],
            state: "Состояние",
            count: "Кол-во смс",
            send2sms: "Отослать в IDCS SMS Centrs",
            message: "Текст сообщения",
            noclients: "Не выбрано получателей",
            StaticQueries: "Разовая рассылка",
            Schedule: "Автоматическая рассылка",
            schedules: [{
                text: "День рождения",
                value: 0
            }, {
                text: "День имени",
                value: 1
            }, {
                text: "Сгораемая сумма",
                value: 2
            }],
            steps: [{
                text: "Выбор получателей",
                value: 1
            }, {
                text: "Фильтр",
                value: 2
            }, {
                text: "Результат выбора",
                value: 3
            }, {
                text: "Сообщение",
                value: 4
            }, {
                text: "Проверка",
                value: 5
            }, {
                text: "Отправка",
                value: 6
            }],
            cltypes: [{
                text: "SMS",
                value: 0
            }, {
                text: "E-mail",
                value: 1
            }],
            days: [{
                    text: "Отправка в день события",
                    value: 0
                },
                {
                    text: "Отправка за день до события",
                    value: 1
                },
                {
                    text: "Отправка за 2 дня до события",
                    value: 2
                },
                {
                    text: "Отправка за 3 дня до события",
                    value: 3
                },
                {
                    text: "Отправка за 4 дня до события",
                    value: 4
                },
                {
                    text: "Отправка за 5 дней до события",
                    value: 5
                },
                {
                    text: "Отправка за 6 дней до события",
                    value: 6
                },
                {
                    text: "Отправка за неделю до события",
                    value: 7
                },
                {
                    text: "Отправка за месяц до события",
                    value: 30
                }
            ],

            // msgcheck: "Check status",
            // start_unset: "Task unscheduled. Will be schedule at SMS center.",
            smsname: "Имя рассылки",
            sendTitle: "Введите имя для рассылки",
            // from: "From date",
            // type: "Type of client",
            // types: [{ text: "SMS", value: 0 }, { text: "E-mail", value: 1 }],
            // select: "Selection method",
            selects: [{
                    text: "Все клиенты",
                    value: 0,
                    desc: "Список всех клиентов",
                    sort: "Сортировка по общему количеству использований карты"
                },
                {
                    text: "По активности клиентов",
                    value: 4,
                    desc: "Активные клиенты за выбранный период",
                    sort: "Сортировка по дате последней активности"
                },
                {
                    text: "По неактивности клиентов",
                    value: 6,
                    desc: "Клиенты не имеющие посещений за выбранный период",
                    sort: "Сортировка по дате последней активности"
                },
                {
                    text: "По максимальной оплате",
                    value: 1,
                    desc: "Клиенты и сумма их максимальной оплаты за выбранный период",
                    sort: "Сортировка по сумме оплаты"
                },
                {
                    text: "По максимальной покупке",
                    value: 5,
                    desc: "Клиенты и сумма их максимальной покупки за выбранный период",
                    sort: "Сортировка по сумме покупки"
                },
                {
                    text: "По количеству покупок",
                    value: 7,
                    desc: "Клиенты и их количество покупок за выбранный период",
                    sort: "Сортировка по количеству покупок"
                },
                {
                    text: "По остаткам на картах",
                    value: 2,
                    desc: "Клиенты и их остаток средств на карте",
                    sort: "Сортировка по величине остатка"
                },
                {
                    text: "По скидке для карты",
                    value: 3,
                    desc: "Клиенты и их скидка по карте",
                    sort: "Сортировка по величине скидки"
                },
                {
                    text: "По дню имени",
                    value: 8,
                    desc: "Клиенты с наступающим днем имени",
                    sort: "Сортировка по дате создания"
                },
                {
                    text: "По дню рождения",
                    value: 9,
                    desc: "Клиенты с наступающим днем рождения",
                    sort: "Сортировка по дате создания"
                },
                {
                    text: "По уровню скидки",
                    value: 10,
                    desc: "Клиенты с наступающим следующем уровнем скидки",
                    sort: "Сортировка по накоплениям"
                },
            ],
            customval: ["Дата создания", "Сумма покупки", "Остаток на карте", "Скидка по карте", "Последняя сделка", "Сумма регистрации", "Последнее использование", "Кол-во покупок", "", "", "Сумма покупок"],
            tops: [{
                text: "Все",
                value: 0
            }, {
                text: "Первые 5",
                value: 1
            }, {
                text: "Первые 25",
                value: 2
            }, {
                text: "Первые 50",
                value: 3
            }, {
                text: "Свое значение",
                value: 4
            }],
            nameday: [{
                text: "Сегодня",
                value: 0
            }, {
                text: "Завтра",
                value: 1
            }, {
                text: "Послезавтра",
                value: 2
            }, {
                text: "Текущая неделя",
                value: 3
            }],

            dtitle: "Событие для проверки",
            f: {
                discamt: "Остается до нового уровня",
                discperc: "Скидка следующего уровня",
                nameday: "Период поиска",
                txtnameday: "Укажите ограничение поиска по ближайшим именинам",
                phnameday: "Когда будут именины",
                txtperiod: "Ограничение по времени события",
                txtsubcompany: "Ограничение по месту события",
                top: "Кол-во получателей",
                txttop: "Ограничение количества получателей",
                next: "Следующая проверка события",
                range: "Период",
                phrange: "За все время",
                cltype: "Тип рассылки",
                phsubcompanies: "Все филиалы",
                schedule: "Тип события",
                name: "Название рассылки",
                phname: "Название рассылки с которым она будет зарегестрирована в IDCS SMS Centrs",
                trigger_type: "Тип события",
                message: "Сообщение",
                phmessage: "Введите текст сообщения",
                created: "Создан",
                lastrun: "Дата последнего события",
                lastcode: "Код последнего события",
                total: "Всего сообщений",
                days2trigger: "Предварительная рассылка",
                sendat: "Время рассылки"
            }
        },
        // profile: {
        //     logCount: "записей в журнале",
        //     transCount: "Кол-во транзакций",
        //     validEnd: "действительна до",
        //     validStart: "активирована",
        //     validremain: "осталось",
        //     debet: "Дебет",
        // },
        admin: {
            smsdisclevels: "Описание уровней каскадных скидок. Формат (оборот-сумма до нового уровня/процент) Пример (100-10/10,300-10/15,500-10/15)",
            group_cust: "Дополнительные настройки для рассылок и прочего",
            freecards: "Free cards",
            fwidth: "Ширина фрейма",
            fheight: "Высота фрейма",
            actions: "Действия",
            fcardlen: "Размер точной длины карты в фрейме",
            deflang: "Язык фрейма по умолчанию",
            frames: "Список фреймов",
            usersupp: "Управление доступом",
            errors: "Ошибки",
            functions: "Утилиты",
            reports: "Отчеты",
            users: "Пользователи",
            bins: "Список бинов",
            groups: "Группы",
            scfilter: "",
            errorId: "код",
            errorid: "код",
            iface: "Тип интерфейса",
            def_message: "Глобальное сообщение",
            newcmsonly: "Разрешить вход только для CMS.E-Karte.lv",
            rules: "Правила доступа",
            l_editor_type: "Тип редактора карты",
            editor_type: [
                "Обычный",
                "Параметризированный для рассылок",
            ],
            interface_type: [
                "Админ",
                "Подарочные",
                "Клиентские SJZ",
                "Клиентские сжиг. GRD",
                "Реверсные клиентские",
            ],
            frame_type: [
                "Подарочные",
                "Клиентские SJZ",
                "Клиентские сжиг. GRD",
                "Реверсные клиентские",
            ],
        },
        trans: {
            all_data: "показывать коррекции",
            tooltip: {
                count: "Колличество сделок за выбранный период"
            }
        },
        label: {
            for: "для",
            hidetext: "Только иконки",
            modified: "Обновлено",
            not_found: "Ничего не найдено",
            placeholder: "Введите данные",
            toDisplay: "на экран",
            toXml: "файл (xml)",
            toCsv: "файл (csv)",
            toExcel: "файл (excel)",
            includeAll: "Включить все дополнительные поля",
            excludeAll: "Исключить все дополнительные поля",
            deals: "Номер сделки",
            rowPerPage: "Кол-во записей на странице",
            nodata: "По вашему запросу данных не найдено"
        },
        tooltip: {
            needDisplay: "Снять галочку, что бы показать на мобильного терминала, в таблице бинов",
            mobileParam: "Параметр, используемый в транзакции",
        },
        field: {
            smsuser: "Имя пользователя",
            smspass: "Пароль",
            ccount: "Невыбранных карт в партии",
            acount: "Всего карт в партии",
            params: "Параметры",
            frametype: "Формат возвращаемых данных",
            errors: "Кол-во ошибок",
            hash: "Фрейм ID",
            amount2Eu: ["Сумма параметра 2", "Сумма пополнения", "Сумма пополнения"],
            amount1Eu: ["Сумма параметра 1", "Сумма оплаты", "Сумма оплаты"],
            amount2: ["Запр. пар. 2", "Пополнение", "Оплата кл. картой", "Оплата кл. картой", "Регистрация покупки"],
            amount1: ["Запр. пар. 1", "Оплата", "Регистрация покупки", "Регистрация покупки", "Оплата кл. картой"],
            totalAmount1Eu: ["Сумма параметра 1", "Сумма оплат", "Сумма оплат"],
            totalAmount2Eu: ["Сумма параметра 2", "Сумма пополнений", "Сумма пополнений"],
            d_debet: ["Расчетный остаток на карте", "Расчетный остаток на карте", "Расчетный остаток на карте", "Расчетный остаток на карте", "Расчетный остаток на карте"],
            next_month: "Сжигаемые накопления",
            amount_discount: "Оборот по скидке",
            current_discount: "Текущая скидка",
            current_discount_0: "Текущая скидка",
            points_0: "Очки",
            counter_n: "счетчик",
            bonus_0: "Бонусы",
            discount_n: "Дополнительная скидка",
            discount_0: "Скидка",
            amount_discount_n: "Сумма дополнительной скидки",
            amount_discount_0: "Сумма скидки",
            debit_n: "Сумма накопления",
            debit_0: "Остаток на карте",
            carddetail: "Карта",
            CardDetail: "Карта",
            terminaldetail: "Терминал",
            TerminalDetail: "Терминал",
            id: "Терминал",
            Terminal: "Терминал",
            Company: "Предприятие",
            companyName: "Предприятие",
            SubCompany: "Филиал",
            companySubName: "Филиал",
            debet_nEu: "Накопления",
            debet_0Eu: "Остаток на карте",
            amountDebetEu: "Остаток на карте",
            debetBilance: "Остаток на карте",
            lastUsed: "Последнее использование",
            used: "Кол-во обращений",
            validc: "Срок жизни",
            lastModified: "Последнее изменение",
            System: "Тип карты",
            totalTrans: "Всего сделок",
            cmd: "Command",
            cmd900x: "X-rep",
            cmd900z: "Z-rep",
            cmd1000: "BIN",
            cmd1100: "INFO",
            cmd1200: "TRANS",
            cmd1300: "ROLL",
            cmd1200p: "PRN trans",
            cmd1300p: "PRN roll",
            errorResp: "error resp",
            errorCmd: "error cmd",
            totalc: "total cmd",
            totalp: "total prn",
            firstName: "Кл.инфо 1",
            secondName: "Кл.инфо 2",
            m1: "янв",
            m2: "фев",
            m3: "мар",
            m4: "апр",
            m5: "май",
            m6: "июн",
            m7: "июл",
            m8: "авг",
            m9: "сен",
            m10: "окт",
            m11: "ноя",
            m12: "дек",
            nextMonth: "Сжигаемые накопления",
            regNumber: "Кл.инфо 3",
            day: "День месяца",
            totals: "Поля для суммирования",
            sysdata: "Системные параметры",
            fields: "Поля отчета",
            filtrs: "Фильтрация данных (устаревшее)",
            repid: "Код формулы выборки",
            inputPars: "Входные параметры",
            nameId: "Код перевода",
            sorted: "Поля для сортировки",
            errorId: "Код сообщения",
            password: "Пароль",
            created_: "Дата создания",
            rec_nr: "Номер чека",
            c_company_name: "Информация о карте 3",
            c_company_subname: "Информация о карте 4",
            reg_num: "Информация о карте 5",
            last_name: "Информация о карте 2",
            subcompany_name: "Информация о карте 4",
            company_name: "Информация о карте 3",
            regnr: "Информация о карте 5",
            additional: "Дополнительно",
            last_trans: "Дата последней сделки",
            counter: "Количество сделок",
            amount_debit: "Остаток на карте",
            ovalid: "Срок действия до",
            validcd: "Срок действия до",
            user_group: "Группа",
            pattern: "Шаблон",
            pos: "#",
            pin: "WEB PIN",
            bad_used: "Кол-во ошибок",
            last_used: "Последнее использование",
            created: "Дата и время",
            dt: "Дата и время",
            req_dt: "Запрос создан",
            last_modified: "Изменена",
            modified: "Изменена",
            req_command: "Команда",
            code: "Код ответа",
            message: "Ответ на терминале",
            ip: "IP",
            name: "Название",
            card: "Карта",
            req_ms: "Карта",
            status: "Статус",
            dbtMinus: "Сумма оплат",
            dbtPlus: "Сумма пополнений",
            repNo: "Отчет #",
            lastResponseId: "ID ответа",
            lastRequestId: "ID запроса",
            operation: "Вид использования",
            Operation: "Вид использования",
            terminal: "Терминал",
            req_terminal: "Терминал",
            system: "Тип карты",
            operNrDef: "Операция по умолчанию",
            bin: "Бин",
            justTrans: "Регистрация",
            needOperNr: "Нужен ввод операции",
            debetIn: "Возможность пополнения",
            extset: "Дополнительно",
            pinFlag: "Управление пин",
            checkSumFormula: "Формула проверки карты",
            valid: "Срок действия",
            operNr: "Номер операции",
            reversal: "Возможность отмены",
            req_id: "id запроса",
            resp_id: "id ответа",
            receipt: "Номер чека",
            resp_dt: "дата ответа",
            par1: "Параметр 1",
            par2: "Параметр 2",
            flags: "флаги",
            resp1: "скидка 0",
            resp2: "сумма скидки 0",
            resp3: "сумма дебет 0",
            resp4: "Заработанные баллы",
            resp5: "бонус",
            resp6: "скидка N",
            resp7: "сумма скидки N",
            resp8: "Дебет N",
            resp9: "счетчик",
            type: "тип",
            needPrint: "Печать чека",
            needDisplay: "Ответ на экране POS",
            formula: "Формула",
            company: "Предприятие",
            subcompany: "Филиал",
            company_subname: "Филиал",
            first_name: "Информация о карте 1",
            second_name: "Информация о карте 2",
            recr_nr: "Рег.нр.",
            initFormula: "Формула инициализации",
            refCard: "Карта владелец",
            realDate: "Реальная дата",
            lang: "язык",
            state: "Состояние",
            reversed: "Отменена"
        },
        menu: {
            tools: "Системные функции",
            structura: 'Структура',
            transactions: "Сделки",
            info: "Информация",
            cards: "Карты",
            profiles: "Рассылки",
            reports: "Отчеты",
            logs: "Журнал",
            title: "E-Karte manager",
            logout: "Выход",
            actlog: "Журнал API",
            posreports: "POS отчеты",
            tickets: "Заявки",
            carddetail: "Подробно о карте",
        },
        summary: {
            tt: {
                total: "Общая сумма сделок",
                avg: "Средняя сумма сделки",
                count: "Колличество сделок"
            },
            day: "статистика за день",
            amount1: "Оплата картой",
            month: "статистика за месяц"
        },
        card: {
            legend: {
                bilance: "Остаток на карте",
                reversal: "Отмена сделки",
                reversed: "Отмененная сделка",
                purchase: ["Запр.пар.1 > 0", "Оплата картой", "Регистрация покупки", "Регистрация покупки", "Оплата картой"],
                sell: ["Запр.пар.2 > 0", "Пополнение карты", "Оплата картой", "Оплата картой", "Регистрация покупки"],
                error: "Ошибка при действии",
                burn: "Сгорание накоплений",
                info: "Проверка состояния карты",
                display: "Ответ на терминале"
            },
            command: {
                "1100": "Проверка состояния карты",
                "1200true": ["Запр.пар.1 > 0", "Оплата картой", "Регистрация покупки", "Регистрация покупки", "Оплата картой"],
                "1200false": ["Запр.пар.2 > 0", "Пополнение карты", "Оплата картой", "Оплата картой", "Регистрация покупки"],
                "1300": "Отмена сделки",
                "900": "Отчет на терминале",
                "1000": "Настройки терминала"
            },
            acc: {
                operation: "Вид использования",
                valid: "Активна до",
                used: "Кол-во использований"
            },
            prof: {
                title: "Анкетные данные",
                first_name: "Владелец",
                second_name: "ID",
                reg_num: "Дата рождения, email и т.д.",
                bdays: "Дата рождения",
                company_name: "Информация 1",
                company_subname: "Информация 2",
                additional: "Дополнительная информация",
                phone: "Телефон",
                email: "E-mail",
                add_date: "Добавить дату"
            },
            stats: {
                recr_nr: "Номер последнего чека",
                created: "Дата создания карты",
                validto: "Возможность использовать до",
            },
            tooltip: {
                asc: "По возрастанию",
                desc: "По убыванию",
                logs: "Действия оператора и ответ на терминале",
                trans: "Сделки по карте",
                bilance: "Изменение остатка средств на карте после завершения сделки",
                valid: "Использование карты блокировано по сроку действия",
                ok: "Карта активизирована и используется",
                free: "Карта не активизирована",
                status1: "Карта списана",
                status2: "Карта заблокирована",
                bad_used_w: "Большое колличество ошибок может привести к ограничению оплаты картой в web магазине",
                bad_used_e: "Внимание! Возможно оплата картой в web магазине ограничена",
            },
            field: {
                sourceCard: "Исходная карта",
                card2copy: "Карта для получения копии данных",
                created: "Дата и время",
                command: "Действие",
                p1: ["Запр. пар. 1", "Сумма оплаты", "Регистрация покупки", "Регистрация покупки", "Оплата кл. картой"],
                p2: ["Запр. пар. 2", "Сумма пополнения", "Оплата кл. картой", "Оплата кл. картой", "Регистрация покупки"],
                resp3: "Остаток на карте",
                message: "Ответ на терминале",
                receipt: "Кол-во сделок",
                ocreated: "Первое использование",
                valid: "Возможность использовать до"
            },
            accbilance: "Накопления на карте",
            turnover: "Оборот по карте",
            currperc: "Расчетный процент",
            filt_status: "Статус активности карты",
            common: "Общие данные",
            timeline: "История работы",
            validfrom: "Дата активации",
            validto: "Срок действия",
            valid: "годна до",
            receipt: "Сделка",
            to: "сегодня",
            from: "активирована",
            add_user_data: "Данные о пользователе",
            stat: "Статистика карты",
            last_used: "Последнее использование",
            total_deals: "Всего сделок по карте",
            profile: "Срок действия карты",
            accounts: "Состояние карты",
            data: "Анкетные данные",
            trans: "Сделки",
            logs: "Действия",
            until: "Оставшееся время использования",
            debet: "Остаток на карте",
            bilance: "Остаток на карте",
            transCount: "Всего сделок",
            logCount: "Записей в журнале",
            status: {
                archived: "списана",
                blocked: "заблокирована",
                inactive: "не активирована",
                awaiting: "не активирована",
                blockedByValid: "просрочена"
            }
        },
        status: {
            "200": "сделка",
            "201": "Отмена сделки",
            "202": "Сделка отменена",
            "203": "Авто-отмена сделки",
            "100": "Активна",
            "500": "Сгорание накоплений",
            "1": "Списана",
            "2": "Блокирована",
        },
        showZeroTypes: {
            all: "Все карты",
            exclude: "Карты с остатками средств",
            only: "Карты с нуллевым остатком"
        },
        report: {
            showZero: "Фильтр по остаткам на картах",
            title: {
                cards: "Список карт",
                trans: "Список сделок",
                logs: "Журнал",
            },
            title1: "Параметры фильтрации выбираемых данных по месту и времени",
            title2: "Параметры фильтрации выбираемых данных по типу",
            title3: "Включение дополнительной информации в отчет",
            amt: {
                all: "Все сделки",
                amt1: "Только оплата картой",
                amt2: "Только пополнения карты"
            },
            grp: {
                terminal: "Группировка по терминалу",
                shop: "Группировка по филиалу"
            },
            amt1: "amy1",
            amt2: "amt2",
            udata: "Добавить информацию о владельце",
            edata: "Добавить расширенную информацию о сделке",
            types: "Валидность карт",
            cards: "Список карт",
            created: "Дата создания отчета",
            params: {
                from: "Начало выборки",
                to: "Конец выборки",
                term: "Терминал",
                scomp: "Филиал",
                udata: "Данные о пользователе",
                edata: "Расширенные данные",
                sysId: "Тип карты",
                amt: "Фильтр",
                card: "Карта"
            },
            tt: {
                actions: "Выберите вариант получения данных",
                sorted: "Параметр старых отчетов, для новых код картинки , к примеру @1",
            }
        },
        error: {
            login: "Проверьте введенные данные! Вход пользователя с такими данными не возможен.",
            required: "Это поле обязательно для ввода",
            digits: "Только цифры",
            length: "Некорректная длина поля"
        },
        byLog: {
            true: "журнал",
            false: "сделки",
        },
        sortDesc: {
            true: "по убыванию",
            false: "по возрастанию",
        },
        picker: {
            today: "сегодня",
            yesterday: "вчера",
            currentWeek: "тек.неделя",
            currentMonth: "тек.месяц",
            previousMonth: "пред.месяц",
            previousWeek: "пред.неделя",
            fromPreviousMonth: "с пред.мес.",
            fromStartYear: "тек.год"
        },
        command: {
            '1100': "Проверка",
            '1200': "Сделка",
            '1300': "Отмена"
        },
        recStatus: [{
                "value": 100,
                "text": "Работает"
            },
            {
                "value": 2,
                "text": "Блокирована"
            },
            {
                "value": 1,
                "text": "Списана"
            },
        ],
        session: {
            title: "Предупреждение",
            text: "Ваша сессия была неактивна уже достаточно долго. Для продолжения работы просто закройте это окно, иначе мы автоматически закроем вашу текущую сессию!",
        },
        rules: {
            read: "чтение",
            create: "создание",
            update: "изменение",
            delete: "удаление",
            menu: "Управление доступом к меню и загрузкой структуры",
            functions: "Управление доступом к точечным акциям пользователя",
            records: "Точечная настройка доступа к типам записей",
            struct_r: "Структура(пункт меню)",
            struct_m: "Структура предприятия",
            struct_s: "Структура типов карт",
            struct_l: "Структура для фильтров",
            summary_r: "Общая информация(пункт меню)",
            trans_r: "Сделки (пункт меню)",
            cards_r: "Карты (пункт меню)",
            report_r: "Отчеты (пункт меню)",
            stats_r: "Графики (пункт меню)",
            log_r: "Журнал (пункт меню)",
            utils_r: "Админ (пункт меню)",
            cardDets_r: "Карты детально(пункт меню)",
            info_r: "Инфо (пункт меню)",
            export_r: "Экспорт (пункт меню)",
            remote_r: "Удаленный доступ (пункт меню)",
            fstat_w: "Смена статуса",
            fpin_r: "Чтение пина",
            posreport_r: "POS отчеты",
            fpin_w: "Смена пина",
            profiles_r: "Профили (пункт меню)",
            fcopy_t: "Копирование данных карты",
            actlog_r: "Журнал изменений",
            fvalid_w: "Установка срока действия",
            fmode_s: "Переключение интерфейсов",
            fcused_y: "Clear card bad used",
        },
        msg: {
            pin: {
                ok: "Пин карты изменен успешно",
                fail: "Что-то пошло не так"
            },
            clone: {
                ok: "Данные карты скопированы успешно",
                fail: "Что-то пошло не так"
            },
            valid: {
                ok: "Срок годности карты изменен успешно",
                fail: "Что-то пошло не так"
            },
            insert: {
                ok: "Запись добавлена успешно",
            },
            delete: {
                ok: "Запись удалена успешно",
            },
            update: {
                ok: "Запись изменена успешно",
            },
            status: {
                ok: "Статус карты изменен успешно",
                fail: "Что-то пошло не так"
            }
        },
        help: {
            func: "<b>Функции пользователя</b>",
            welcome: "Добро пожаловать в обновленную версию проекта E-karte Manager",
            home: {
                searchByCard: "Для поиска информации по карте (анкеты клиента, истории использования карты), а также для продления срока действия карты",
                searchByClient: "Для поиска утерянной клиентской карты, введите любую информацию клиента из анкетных данных",
                searchByTrans: "Для поиска проданной подарочной карты, введите сумму пополнения карты, выберите дату, сумму и место продажи"
            },
            menu: {
                posreports: "POS отчеты",
                structura: "Отображение структуры предприятия и типов карт",
                cards: "Список карт, информация об использовании карты и владельце, управление картой",
                transactions: "Информация о карточных сделках",
                info: "Обобщенная информация о сегодняшнем дне и прошлом месяце, информация о последних сделках и ошибках",
                home: "Вернуться в начало",
                reports: "Шаблоны отчетов",
                profiles: "Формирование групп для рассылок",
                logs: "События системы",
                tickets: "Заявки"
            },
            intro: "<p>Данный проект обеспечивает генерацию статистики и управление электронной системы лояльности и системы подарочных карт." +
                "</p><p><b>Что нового:</b></p><p></p><p>Мы тщательно переработали методику работы с большими обьемами данных, улучшили экспорт данных и для " +
                "облегчения предоставили возможность приоброзования данных в MS Excel для дальнейшего анализа.</p><p>Для облегчения работы мы вынесли наиболее " +
                "популярные функции на это окно</p><p>Если у Вас возникли вопросы по пользованию данной веб страницы, есть предложения по ее улучшению или вы заметили " +
                "какую либо неточность в работе, просим Вас связаться с нашей технической поддержкой по телефону <a href='maito:+37167277233'>67277233</a> или прислать описание проблемы/предложения по " +
                "улучшению на е-майл <a href='maito:help@idcs.lv'>help@idcs.lv</a></p>"
        },
    }
}
// Create VueI18n instance with options
let l = localStorage.getItem("lang");
if (l == null) l = "en";
const i18n = new VueI18n({
    locale: l, // set locale
    silentTranslationWarn: false,
    fallbackLocale: "en",
    messages // set locale messages
})

export default i18n;